module.exports = __webpack_public_path__ + "img/Independence Day 2.4237b705.jpeg";